import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <Header />

      <div className="policy-page">
        <div className="policy-hero">
          <h1>Privacy Policy</h1>
          <p>
            Your privacy is important to us. We are committed to protecting your
            personal information and ensuring transparency in how we use your
            data.
          </p>
        </div>

        <div className="policy-container">
          <section className="policy-card">
            <h2>1. Information We Collect</h2>
            <p>
              We may collect personal information including your name, email
              address, shipping address, billing information, phone number,
              device information, and browsing behavior when you interact with
              our website.
            </p>
          </section>

          <section className="policy-card">
            <h2>2. How We Use Your Information</h2>
            <p>
              Your information is used to process orders, provide customer
              support, improve our services, personalize your experience, and
              communicate important updates regarding your purchases.
            </p>
          </section>

          <section className="policy-card">
            <h2>3. Payment Security</h2>
            <p>
              All payments are processed through secure third-party payment
              providers. We do not store your full payment card information on
              our servers.
            </p>
          </section>

          <section className="policy-card">
            <h2>4. Cookies & Analytics</h2>
            <p>
              We use cookies and analytics technologies to improve website
              functionality, measure traffic, and optimize user experience.
            </p>
          </section>

          <section className="policy-card">
            <h2>5. Third-Party Services</h2>
            <p>
              We may share limited information with logistics providers, payment
              processors, and analytics partners strictly for business
              operations and order fulfillment.
            </p>
          </section>

          <section className="policy-card">
            <h2>6. Data Protection</h2>
            <p>
              We implement industry-standard security measures to protect your
              personal information against unauthorized access, misuse, or
              disclosure.
            </p>
          </section>

          <section className="policy-card">
            <h2>7. Your Rights</h2>
            <p>
              You may request access, correction, or deletion of your personal
              information by contacting our support team.
            </p>
          </section>

          <section className="policy-card">
            <h2>8. Policy Updates</h2>
            <p>
              We reserve the right to update this Privacy Policy at any time.
              Changes will be posted on this page with updated effective dates.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Privacy;
